import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  host: {
    '(window:scroll)': 'onScroll($event)'
  },
  styleUrls: ['./header.component.scss'],

})
export class HeaderComponent implements OnInit {

  constructor(private router: Router) { }
  activeElement: string;
  isScrolled = false;
  currPos: Number = 0;
  startPos: Number = 0;
  changePos: Number = 40;
  scrollingBar:boolean=true;
  isMenuBar: boolean;
  ngOnInit(): void {
    this.scroll();
    window.addEventListener('scroll', this.scrolling, this.scrollingBar);
    if( this.router.url == '/') {
      this.activeElement = 'home';
      } else if ( this.router.url == '/about') {
        this.activeElement = 'about';
      } else if ( this.router.url == '/services') {
        this.activeElement = 'services';
      }else if ( this.router.url == '/industries') {
        this.activeElement = 'industries';
      }else if ( this.router.url == '/technology') {
        this.activeElement = 'technology';
      }else if ( this.router.url == '/client') {
        this.activeElement = 'client';
      }    else if ( this.router.url == '/contact') {
        this.activeElement = 'contact';
      } else {
        this.activeElement = '*';
      }
  }

  scrolling=(s)=>{
     if( this.router.url == '/') {
      this.activeElement = 'home';
      } else if ( this.router.url == '/about') {
        this.activeElement = 'about';
      } else if ( this.router.url == '/services') {
        this.activeElement = 'services';
      }else if ( this.router.url == '/industries') {
        this.activeElement = 'industries';
      }else if ( this.router.url == '/technology') {
        this.activeElement = 'technology';
      }else if ( this.router.url == '/client') {
        this.activeElement = 'client';
      }
      else if ( this.router.url == '/contact') {
        this.activeElement = 'contact';
      } else {
        this.activeElement = '*';
      }
   }
 

  onScroll(evt) {
    this.currPos = (window.pageYOffset || evt.target.scrollTop) - (evt.target.clientTop || 0);
    if (this.currPos >= this.changePos) {
      this.isScrolled = true;
    } else {
      this.isScrolled = false;
    }
  }
  onMenu() {
    this.isMenuBar = !this.isMenuBar;
  }

  scroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onUpdateActive(str){
    this.isMenuBar = false;
    if(str == 'home') {
      this.activeElement = 'home';
      } else if (str == 'about') {
        this.activeElement = 'about';
      } else if (str == 'services') {
        this.activeElement = 'services';
      }else if (str == 'industries') {
        this.activeElement = 'industries';
      }else if (str == 'technology') {
        this.activeElement = 'technology';
      }else if (str == 'client') {
        this.activeElement = 'client';
      } else if (str == 'contact') {
        this.activeElement = 'contact';
      } else {
        this.activeElement = '^'
      }
      this.scroll();
  }



}
